
import { defineComponent } from 'vue';

import TestimonialSwipers from '@/components/HospitalsHomePage/TestimonialsSwipers.vue';

export default defineComponent({
  components: { TestimonialSwipers },
});
